// Warms the browser's HTTP cache for an HLS manifest URL.
// Uses fetch() rather than <link rel="prefetch"> because hls.js resolves manifests via XHR,
// which reads from the HTTP cache — not from the separate prefetch buffer browsers maintain.
export const warmHlsManifest = (url: string): void => {
  fetch(url, { cache: 'default' }).catch(() => {});
};
